<template>
  <b-form-select   v-model="curId" size="sm">
    <option v-for="state in states" :key="state.abbr" :value="state.abbr">
      {{ state.name }}
    </option>
  </b-form-select>
</template>



<script>
import {STATES} from "@/shared/constants";
  export default {
    props: ['stateId'],
    data() {
      return {
        curId: '--',
        states: STATES
      }
    },
    watch: {
      curId(val) {
        // alert(val);
        var obj = this.states.find(state => state.abbr === val);
        this.$emit('onChange', obj);
      },
      stateId(val) {
        this.curId = val;
      }
    },

    mounted: function() {
      this.$nextTick(function(){
        if(this.stateId != undefined)
          this.curId = this.stateId;
      })
    }
  }
</script>